"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderMedia = exports.MediaImage = exports.MediaVideo = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const placeholderMediaColor = '#E6E6E6';
const mediaItemBoxShadow = '#C1C1C1 3px 3px 5px 1px';
const setStyle = (props) => {
    const { style } = props;
    return (0, styled_components_1.css) `
    ${style && (0, styled_components_1.css)(style)}
  `;
};
const setBorderRadius = (props) => {
    return (0, styled_components_1.css) `
    border-radius: ${props.borderRadius};
  `;
};
const setMargin = (props) => {
    return (0, styled_components_1.css) `
    margin: ${props.margin};
  `;
};
const setHeight = (props) => {
    return (0, styled_components_1.css) `
    height: ${props.height};
  `;
};
const setWidth = (props) => {
    return (0, styled_components_1.css) `
    width: ${props.width};
  `;
};
const setMaxWidth = (props) => {
    if (props.maxWidth) {
        return (0, styled_components_1.css) `
      max-width: ${props.maxWidth};
    `;
    }
    else {
        return null;
    }
};
const setMinWidth = (props) => {
    if (props.minWidth) {
        return (0, styled_components_1.css) `
      min-width: ${props.minWidth};
    `;
    }
    else {
        return null;
    }
};
const setCursor = (props) => {
    return (0, styled_components_1.css) `
    cursor: ${props.onClick ? 'pointer' : 'auto'};
  `;
};
const setObjectFit = (props) => {
    return (0, styled_components_1.css) `
    object-fit: ${props.objectFit ? props.objectFit : 'cover'};
  `;
};
const setItemBoxShadow = (props) => {
    return (0, styled_components_1.css) `
    box-shadow: ${props.itemBoxShadow ? `${mediaItemBoxShadow}` : ''};
  `;
};
exports.MediaVideo = styled_components_1.default.video `
  pointer-events: 'none';
  width: 100%;
  height: 100%;
  ${setObjectFit};
  ${setBorderRadius}
  ${setItemBoxShadow}
  ${setMaxWidth}
  ${setCursor}
  ${setStyle}
  ${setHeight}
`;
exports.MediaImage = styled_components_1.default.img.attrs((props) => {
    return Object.assign(Object.assign({}, props), { 'data-src': props['data-src'] });
}) `
  ${setBorderRadius}
  ${setItemBoxShadow}
  ${setMaxWidth}
  ${setCursor}
  ${setStyle}
  ${setMargin}
  ${setHeight}
  ${setWidth}
  ${setMinWidth}
`;
exports.PlaceholderMedia = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  background-color: ${placeholderMediaColor};
`;
